import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { buildReschedulePayload, toDatetimeLocalValue } from "../utils/calendarHelpers";

export default function EventRescheduleModal({ open, event, onClose, onSubmit, loading }) {
    const [form, setForm] = useState({ dateDebut: "", dateFin: "" });

    useEffect(() => {
        if (!open || !event) return;
        setForm({
            dateDebut: toDatetimeLocalValue(event.dateDebut),
            dateFin: toDatetimeLocalValue(event.dateFin),
        });
    }, [event, open]);

    if (!open || !event) return null;

    const handleSubmit = (submitEvent) => {
        submitEvent.preventDefault();
        onSubmit(buildReschedulePayload(event.id, form));
    };

    return (
        <div className="calendar-modal-backdrop" onClick={onClose}>
            <div className="calendar-modal calendar-modal--small" onClick={(eventTarget) => eventTarget.stopPropagation()}>
                <div className="calendar-modal__header">
                    <div>
                        <div className="calendar-modal__eyebrow">Replanification</div>
                        <h2>Replanifier l'evenement</h2>
                    </div>
                    <button type="button" className="calendar-icon-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <form className="calendar-modal__body" onSubmit={handleSubmit}>
                    <div className="calendar-form-grid">
                        <label className="calendar-field">
                            <span>Nouveau debut</span>
                            <input
                                required
                                type="datetime-local"
                                value={form.dateDebut}
                                onChange={(eventTarget) => setForm((current) => ({ ...current, dateDebut: eventTarget.target.value }))}
                            />
                        </label>
                        <label className="calendar-field">
                            <span>Nouvelle fin</span>
                            <input
                                required
                                type="datetime-local"
                                value={form.dateFin}
                                onChange={(eventTarget) => setForm((current) => ({ ...current, dateFin: eventTarget.target.value }))}
                            />
                        </label>
                    </div>

                    <div className="calendar-modal__footer">
                        <button type="button" className="calendar-btn calendar-btn--ghost" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" className="calendar-btn calendar-btn--primary" disabled={loading}>
                            {loading ? "Replanification..." : "Replanifier"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
